import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { StyledUILink } from '../../styles/TextInput.styles';
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BackLink = ({
  onClick,
  href = ''
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(Flex, {
    inlineSize: "fit-content",
    children: isCanvasTheme(theme) ? /*#__PURE__*/_jsx(Link, {
      href: href,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(StyledUILink, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(LeftIcon, {
            size: "300"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'button.back'
          })]
        })
      })
    }) : /*#__PURE__*/_jsx(Button, Object.assign({}, href && {
      href
    }, {
      onClick: onClick,
      use: "transparent",
      paddingInlineStart: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(LeftIcon, {
          size: "200"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'button.back'
        })]
      })
    }))
  });
};